__turbopack_context__.v({
  "container": "PageSpinner-module__3Lrv5q__container",
  "letter": "PageSpinner-module__3Lrv5q__letter",
  "logo": "PageSpinner-module__3Lrv5q__logo",
  "logoAppear": "PageSpinner-module__3Lrv5q__logoAppear",
  "overlay": "PageSpinner-module__3Lrv5q__overlay",
  "text": "PageSpinner-module__3Lrv5q__text",
  "textReveal": "PageSpinner-module__3Lrv5q__textReveal",
});
